import React, { useEffect, useState } from "react";

interface props {
    name: string,
    value: string,
    label?: string,
    placeholder?: string,
    isDisabled?: boolean,
    onChange: (changeValue: string) => void
}

const TextInput = (props: props) => {

    const groupTextId = props.name + 'label';
    const inputId = props.name + '-input';

    const [inputValue, setInputValue] = useState<string>(props.value);
    const [inputLabel, setInputLabel] = useState<string>('');
    const [inputPlaceholder, setInputPlaceholder] = useState<string>('');
    const [isDisabled, setIsDisabled] = useState<boolean>(false);

    const handleChange = (event: any) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        props.onChange(newValue);
    };

    useEffect(() => {
        if (typeof props.label !== 'undefined') {
            setInputLabel(props.label);
        }

        if (typeof props.placeholder !== 'undefined') {
            setInputPlaceholder(props.placeholder);
        }
        setInputValue(props.value);

        if (typeof props.isDisabled !== 'undefined') {
            setIsDisabled(props.isDisabled);
        }
    }, [props]);


    return (
        <div className="input-group formElement">
            {inputLabel !== '' ?
                <span className="input-group-text text-start align-items-start" id={groupTextId}>{inputLabel}</span>
                : null}
            <input id={inputId}
                name={inputId}
                type="text"
                className="form-control"
                placeholder={inputPlaceholder}
                aria-label={inputLabel}
                aria-describedby={groupTextId}
                value={inputValue}
                disabled={isDisabled}
                onChange={handleChange}
            />
        </div>
    )
}

export { TextInput };
